import { render, staticRenderFns } from "./comment-actions-menu.vue?vue&type=template&id=a05c2eb2&"
import script from "./comment-actions-menu.vue?vue&type=script&lang=js&"
export * from "./comment-actions-menu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports